import AutomationError from './AutomationError';
class InvestorSatValidationFailed extends AutomationError {
    constructor(options) {
        super('The invoice failed SAT validation.', options);
    }
}
export default InvestorSatValidationFailed;
